import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { I18nProvider } from './i18n/I18nProvider';
import { setLanguage } from './api/endpoints';
import { tokenStore } from './api/client';
import type { Lang } from './i18n/dictionary';
import './styles/tokens.css';
import './styles/app.css';

/** Volbu jazyka ukládáme na uživatele; bez přihlášení nemá kam. */
async function persistLanguage(lang: Lang) {
  if (!tokenStore.get()) return;
  await setLanguage(lang);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nProvider persist={persistLanguage}>
      <App />
    </I18nProvider>
  </StrictMode>,
);
